import { DropdownOption } from '../components/ui/Dropdown/Dropdown.types';
import { ComplianceStatus } from '../types/AISystems.types';
import type { FetchAISystemsParams } from '../services/AISystemsService';
import type { AISystemsState } from '../store/slices/aiSystemsSlice';

export function convertToDropdownOptions<T extends Record<string, any>>(
  items: T[],
  labelKey: keyof T,
  valueKey: keyof T
): DropdownOption[] {
  return items.map((item) => ({
    label: String(item[labelKey]),
    value: String(item[valueKey])
  }));
}

export type AISystemsQuerySource = Pick<
  AISystemsState,
  'filters' | 'pagination' | 'sorting'
>;

// Single source of truth for slice state -> GET /ai-systems params. Every list
// refresh must go through this: a filter added to the slice but forgotten at one
// call site silently widens that refresh's scope - regulationCode was dropped by
// the bulk-import refresh exactly this way, so an import replaced a
// regulation-scoped list with every regulation's systems.
export const buildAISystemsQuery = (
  { filters, pagination, sorting }: AISystemsQuerySource,
  overrides: Partial<FetchAISystemsParams> = {}
): FetchAISystemsParams => ({
  search: filters.search,
  regulationCode: filters.regulationCode,
  entity: filters.entity,
  riskClassification: filters.riskClassification,
  complianceStatus: filters.complianceStatus,
  ownerId: filters.owners,
  organization: filters.organization,
  accountId: filters.accountId,
  offset: pagination.offset,
  limit: pagination.limit,
  sortBy: sorting.sortBy,
  order: sorting.order,
  ...overrides
});
